import React from "react";
import "./QuickAccess.css";

export default function QuickAccessCard({ title, buttonText, buttonLink, highlight }) {
  return (
    <div className={`quick-access-card${highlight ? " highlight" : ""}`}>
      <div className="quick-access-title">
        {title.split("\n").map((line, i) => (
          <React.Fragment key={i}>
            {line}
            <br />
          </React.Fragment>
        ))}
      </div>
      <a href={buttonLink} className="quick-access-btn">
        {buttonText}
      </a>
    </div>
  );
} 